export default __webpack_public_path__ + "static/N0165-3743a0e0b8680dbf890b34158bc852e6.png";